import { useEffect } from 'react';

import { updateNotification } from '@/fetchers/notifications';
import { useQueryParams } from '@/hooks/useQueryParams';
import { useStores } from '@/hooks/useStores';
import { StringParam } from '@/utils/url-query-string';

export const useSetReadNotification = () => {
  const { notificationId } = useQueryParams<{ notificationId: string }>({
    notificationId: StringParam,
  });

  const { store } = useStores();

  useEffect(() => {
    if (notificationId) {
      updateNotification(store, notificationId, { read: true });
    }
  }, [notificationId, store]);
};
